import { render, staticRenderFns } from "./TestCategoryList.vue?vue&type=template&id=c4c647a8&scoped=true&"
import script from "./TestCategoryList.vue?vue&type=script&lang=js&"
export * from "./TestCategoryList.vue?vue&type=script&lang=js&"
import style0 from "./TestCategoryList.vue?vue&type=style&index=0&id=c4c647a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c647a8",
  null
  
)

export default component.exports